module.exports = __webpack_public_path__ + "img/prnoar.02a03aec.png";